export default "/_next/static/images/465ca99915d7c597d37f59cc5b74df54.png";